import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
 
const RegisterjackpotCreate = ()=>{
     const [jackpotname, setJackpotname ] = useState('');
     const [period, setPeriod ] = useState('');
     const [datehour, setDatehour ] = useState('');
     const [amount, setAmount ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
        // console.log("JACKS ANME: "+jackpotname);
         const {data} = await axios.post('registerJackpot', {
            jackpot_name:jackpotname,
            period,
            date_hour:datehour,
            amount:parseInt(amount),
        });
       // console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/registerjackpot'} />
    }
     return (
         <Wrapper pageTitle={"New Registerjackpot"}>
            <InnerNav createLink={'/registerjackpotCreate'} listLink={'/registerjackpot'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Jackpot Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Jackpot Name"
                        onChange = {e => setJackpotname(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Period </span>
                        <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Period"
                        onChange = {e => setPeriod(e.target.value)} >
                            <option value="">Choose Period</option>
                            <option>hour</option>
                            <option>day</option>
                            <option>week</option>
                            </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date Hour </span>
                        <input type="datetime-local"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Datehour"
                        onChange = {e => setDatehour(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount"
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default RegisterjackpotCreate;